export default function ComparisonSection() {
  const rows = [
    { feature: 'Product Discovery Speed', allchina: 'Instant', manual: 'Slow', typical: 'Medium' },
    { feature: 'Trend Detection', allchina: 'AI-based', manual: 'None', typical: 'Basic' },
    { feature: 'Supplier Comparison', allchina: 'Built-in', manual: 'Manual', typical: 'Limited' },
    { feature: 'Data Freshness', allchina: 'Daily Updated', manual: 'Outdated', typical: 'Weekly' },
    { feature: 'Beginner Friendly', allchina: 'Very High', manual: 'Low', typical: 'Medium' },
    { feature: 'Margin Calculator', allchina: 'Automatic', manual: 'Manual', typical: 'None' },
  ];

  return (
    <section id="comparison" className="bg-background-50 py-20 md:py-28">
      <div className="w-full px-6 md:px-10 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-3">
            How We Compare
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            See why AllChinaBuySpreadsheet outperforms traditional product sourcing methods.
          </p>
        </div>

        {/* Table */}
        <div className="overflow-x-auto rounded-xl border border-background-200/60">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200/60 bg-background-100">
                <th className="text-left px-6 py-4 font-semibold text-foreground-800 whitespace-nowrap">Feature</th>
                <th className="text-left px-6 py-4 font-semibold text-primary-600 whitespace-nowrap">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-star-fill text-xs"></i>
                    AllChinaBuySpreadsheet
                  </span>
                </th>
                <th className="text-left px-6 py-4 font-semibold text-foreground-600 whitespace-nowrap">Manual Research</th>
                <th className="text-left px-6 py-4 font-semibold text-foreground-600 whitespace-nowrap">Typical Tools</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={row.feature} className={`border-b border-background-200/60 ${i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}>
                  <td className="px-6 py-4 text-foreground-800 font-medium whitespace-nowrap">{row.feature}</td>
                  <td className="px-6 py-4">
                    <span className="inline-flex items-center gap-1.5 text-primary-600 font-semibold whitespace-nowrap">
                      <i className="ri-checkbox-circle-fill text-xs"></i>
                      {row.allchina}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-foreground-500 whitespace-nowrap">{row.manual}</td>
                  <td className="px-6 py-4 text-foreground-500 whitespace-nowrap">{row.typical}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Insight */}
        <div className="mt-8 p-6 bg-accent-100/50 rounded-xl border border-accent-200/60">
          <p className="text-foreground-800 text-sm leading-relaxed">
            <strong className="text-foreground-950">Key Insight:</strong> Most tools focus on either product listing <span className="text-foreground-500">OR</span> supplier listing. AllChinaBuySpreadsheet combines <strong className="text-foreground-950">BOTH</strong> into one unified system — giving you a complete sourcing workflow in a single spreadsheet.
          </p>
        </div>
      </div>
    </section>
  );
}